import { render } from "./IconXCircle.vue?vue&type=template&id=bce6be7c"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconXCircle.vue"]])

export default __exports__